var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWrenchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 473,
    height: 473,
    viewBox: "0 0 473 473",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_215_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M464.923 85.602L449.989 100.537L390.189 160.338L326.393 146.223L312.28 82.426L372.08 22.625L387.014 7.692C341.223 -8.787 288.055 1.17799 251.364 37.869C218.081 71.151 206.821 117.997 217.289 160.597L217.089 160.398L19.702 357.784C-6.56799 384.054 -6.56799 426.645 19.702 452.915C45.972 479.184 88.562 479.184 114.832 452.915L312.218 255.53L312.016 255.328C354.616 265.796 401.462 254.537 434.746 221.255C471.438 184.564 481.4 131.392 464.923 85.602ZM89.377 425.645C77.668 437.354 58.683 437.354 46.973 425.645C35.263 413.934 35.263 394.949 46.973 383.239C58.683 371.53 77.668 371.53 89.377 383.239C101.087 394.948 101.087 413.934 89.377 425.645Z",
    fill: "#CA5050"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_215_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 472.616,
    height: 472.616,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrenchIcon);
export default __webpack_public_path__ + "static/media/wrench-icon.611e3113237ff129ae3592049904a8fb.svg";
export { ForwardRef as ReactComponent };